<template class="template-edit-language">
    <div class="edit-language">
        <div class="new-point">
            <div class="point-list">
                <div style="color:#505050;height:60px;line-height:60px;padding:0 24px;text-align:left;font-size:16px;">
                    <a-icon style="color:#ccc" type="profile" />
                    <span style="margin-left:4px;color:#aaa">创建节点</span>
                </div>
                <ul>
                    <li @click="addPoint('FLOW')">
                        <a-icon type="plus-circle" />
                        流程节点
                    </li>
                    <li @click="addPoint('SMS')">
                        <a-icon type="plus-circle" />
                        短信节点
                    </li>
                    <li @click="addPoint('TRANSFER')">
                        <a-icon type="plus-circle" />
                        转接节点
                    </li>
                    <li @click="addPoint('FINISH')">
                        <a-icon type="plus-circle" />
                        结束节点
                    </li>
                </ul>
                <!-- <div class="path-bind">
                    <div>通道绑定数量：{{channelCount}}</div>
                    <a-button @click="bindPath" type="primary">
                        通道绑定
                    </a-button>
                </div> -->
            </div>
        </div>
        <div class="content" :class="{'active':ifShowDetail}" id="chatDiv">
            <div class="title" style="padding:24px 54px" @click="selectCurrentItem(null,null,'info')" :class="{'active':-1==selectCurrentIndex}">
                <div style="height:32px;">
                    <div style="float:right">
                        <span style="color:rgba(204, 204, 204, 1);font-size:13px;">已训练：</span>
                        <span style="color:rgba(34, 215, 187, 1);font-size:14px;margin:0 24px 0 0">{{trainedCount}}</span>
                        <span style="color:rgba(204, 204, 204, 1);font-size:13px;">待训练：</span>
                        <span style="color:rgba(34, 215, 187, 1);font-size:14px;margin:0 24px 0 0">{{unTrainedCount}}</span>
                        <a-button @click="startTrain" v-if="!training" type="primary">
                            训练
                        </a-button>
                        <a-button v-if="training" type="primary" disabled style="border:none">
                            训练中...
                        </a-button>
                    </div>
                </div>
                <div style="margin-top:16px">
                    <div>
                        <a-input style="flex:1;text-align:left;font-size:18px;width:100%;color:rgba(51, 51, 51, 1);font-weight:bold" placeholder="请输入项目名称" v-model="projectName" @blur="changeProName()"/>
                    </div>
                </div>
                <div style="clear:both"></div>
                <div style="display:flex;margin:16px 0">
                    <a-textarea placeholder="请输入项目描述" style="line-height:20px;height:65px;resize:none;flex:1" v-model="proDes" @blur="changeProDes()"/>
                </div>
                <div style="height:32px;">
                    <div style="float:left;">
                        <a-select :defaultValue='proSenceId' :key='proSenceId' style="width: 220px;border-color: rgba(238, 238, 238, 1);" @change="selectSence">
                            <a-select-option :title="item.name" :value='item.id' v-for="(item, index) in senceList" :key="index">{{item.name}}</a-select-option>
                        </a-select>
                    </div>
                    <div style="float:right;">
                        <span style="font-size:12px;float:left;margin-top:14px;margin-right:10px;color:rgba(204, 204, 204, 1)">上次更新时间：{{lastUpdateTime}}</span>
                        <a-button type="primary" style="float:left;background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1)" @click="applicationUse">
                            应用配置
                        </a-button>
                    </div>
                </div>
            </div>
            <div class="area">
                <div style="margin-top:16px" :class="{'active':index==selectCurrentIndex}" v-for="(item, index) in nodeList" :key="index" @click="selectCurrentItem(item,index,'node')">
                    <div class="list" v-if="item.type == 'START'">
                        <div class="operation">
                            <span style='background:rgba(237, 243, 254, 1);color:rgba(78, 138, 250, 1)'>开始节点</span>
                            <div v-if="item.coefficientType=='EXCELLENT'" style="color:rgba(30, 216, 255, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/excellent.svg" alt="">
                                <span>优秀</span>
                            </div>
                            <div v-if="item.coefficientType=='NORMAL'" style="color:rgba(53, 108, 255, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/normal.svg" alt="">
                                <span>正常</span>
                            </div>
                            <div v-if="item.coefficientType=='DOUBT'" style="color:rgba(255, 124, 26, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/doubt.svg" alt="">
                                <span>疑问</span>
                            </div>
                            <div v-if="item.coefficientType=='ANGER'" style="color:rgba(255, 0, 109, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/anger.svg" alt="">
                                <span>愤怒</span>
                            </div>
                            <div v-if="item.coefficientType=='COMPLAINT'" style="color:rgba(255, 95, 218, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/complaint.svg" alt="">
                                <span>负面</span>
                            </div>
                            <span style="color:rgba(204, 204, 204, 1);font-size:14px">最大次数：</span>
                            <span style="color:rgba(204, 204, 204, 1)">{{ item.maxTriggerCount }}</span>
                        </div>
                        <div class="area-edit">
                            <span class="serial-number">{{index+1}}</span>
                            <a-input style="font-weight:500" v-model="item.name" @blur="changeLinesName(item)" />
                            <div class="add" @click="addLines(null,item.id)">
                                <span>添加台词</span>
                                <a-icon type="plus-circle"/>
                            </div>
                        </div>
                        <div class="area-list">
                            <div class="list-content" v-for="(talkingItem, talkingIndex) in item.talkingSkillList" :key="talkingIndex">
                                <a-textarea style="line-height:20px;height:65px;font-weight:500" @blur="addLines(talkingItem)" v-model='talkingItem.content' />
                                <div class="remove-line" @click="removeLines(talkingItem.id,item.id)">
                                    <span>删除台词</span>
                                    <a-icon type="minus-circle"/>
                                </div>
                            </div>
                        </div>
                        <div class="distribution" style="width:100%">
                            <div class="up-down" v-if="!boolList[index]" @click='ifShow(index,item.id)' style='position:absolute;right:44px;bottom:0px'>
                                <span>{{item.unDistributeIntentionCount}}个回答待分配</span>
                                <!-- <a-icon type="down" /> -->
                                <img src="../../assets/img/open-close.svg" alt="">
                                <span class="waiting-distribution">{{item.distributeIntentionCount}}</span>
                            </div>
                            
                            <div style="width:80%;padding-bottom:28px">
                                <div v-if="boolList[index]" class="gutter-example">
                                    <a-row :gutter="16">
                                        <a-col class="gutter-row" :span="12" style="max-height:600px;overflow-y:auto">
                                            <div class="gutter-box gutter-box1">
                                                <div class="distribution-text">
                                                    <span>待分配回答（意图）</span>
                                                    <a-button type="primary" @click="addNewIntention" style="float:right">
                                                        新增意图
                                                    </a-button>
                                                </div>
                                                <draggable element="span" v-model="item.unDistributeIntentionList" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" :move="onMove">
                                                    <transition-group type="transition" :name="'flip-list'" tag="ul" class="list-group">
                                                        <li class="idea list-group-item" v-for="(waitingItem, waitingIndex) in item.unDistributeIntentionList" :key="waitingIndex">
                                                            <div>
                                                                {{waitingItem.name}}
                                                                <a-icon @click="editAnswerWay(waitingItem.id)" type="edit" />
                                                                <span>答法：{{waitingItem.sampleCount}}</span>
                                                            </div>
                                                            <a-icon class="add move" type="drag" />
                                                        </li>
                                                    </transition-group>
                                                </draggable>
                                            </div>
                                        </a-col>
                                        <a-col class="gutter-row" :span="12" style="max-height:600px;overflow-y:auto">
                                            <div style="text-align:center;cursor:pointer;margin:10px 0 20px 0">
                                                <a-icon type="plus" />
                                                <span style='margin-left:5px' @click="addJumpLogic(item.id,index)">跳转逻辑</span>
                                            </div>
                                            <div v-if="testArr[index].state" style="min-height:80px;padding:8px;background:#f5f5f5;margin-bottom:10px;border: rgba(166, 166, 166, 1) dotted 1px;">
                                                <div class="add-point">
                                                    <a-select defaultValue="请选择" style="width: 80%" @change="handleChange2" @focus="queryNodeSelectList(null)">
                                                        <a-select-option :title="selectItem.name" :value="selectItem.id" v-for="(selectItem, selectIndex) in optionListData" :key="selectIndex">{{selectItem.name}}</a-select-option>
                                                    </a-select>
                                                    <a-icon @click="removeTemporaryNode" type="delete" style="float:right" />
                                                </div>
                                                <div>
                                                    <draggable element="span" v-model="testArr[index].data" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" @add="addIntention(index,false)">
                                                        <transition-group type="transition" :name="'flip-list'" tag="ul" class="list-group">
                                                            <div class="list-content" v-for="(talkingItem, talkingIndex) in testArr[index].data" :key="talkingIndex">
                                                                <span>{{talkingItem.name}}</span>
                                                                <a-icon class="move" type="drag"/>
                                                                <a-icon type="minus-circle" @click="removeLines(talkingItem.id)"/>
                                                            </div>
                                                        </transition-group>
                                                    </draggable>
                                                </div>
                                            </div>
                                            <div style="text-align:center" v-if="item.nextNodeList==0&&nodeDataList.length==0">
                                                <img style="width:100%" src="../../assets/img/moving.gif" alt="">
                                            </div>
                                            <div class="gutter-box gutter-box2" v-for="(allocateItem, allocateIndex) in item.nextNodeList" :key="allocateIndex">
                                                <div class="add-point">
                                                    <a-select :defaultValue="allocateItem.name" :key="allocateItem.name" style="width: 80%" @change="(e)=>handleChange1(e,allocateItem.id)" @focus="queryNodeSelectList(allocateItem.id)">
                                                        <a-select-option :title="selectItem.name" :value='selectItem.id' v-for="(selectItem, selectIndex) in optionListData" :key="selectIndex">{{selectItem.name}}</a-select-option>
                                                    </a-select>
                                                    <a-icon type="delete" style="float:right" @click="deleteNextNode(allocateItem.id)"/>
                                                </div>
                                                <div>
                                                    <draggable element="span" v-model="allocateItem.intentionList" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" @add="addIntention(allocateItem,true)" :move="onMove">
                                                        <transition-group name="no" class="list-group" tag="ul">
                                                            <li class="list-group-item list-point" v-for="(desItem, desIndex)  in allocateItem.intentionList" :key="desIndex">
                                                                <div>{{desItem.name}}</div>
                                                                <a-icon class="move" type="drag" />
                                                                <a-icon type="minus-circle" @click="deleteAssignedIntention(desItem.id)"/>
                                                            </li>
                                                        </transition-group>
                                                    </draggable>
                                                </div>
                                            </div>
                                        </a-col>
                                    </a-row>
                                </div>
                            </div>
                            <div class="up-down" v-if="boolList[index]" @click='ifShow(index,item.id)' style='position:absolute;right:44px;bottom:0px'>
                                <span>{{item.unDistributeIntentionCount}}个回答待分配</span>
                                <!-- <a-icon type="up" /> -->
                                <img src="../../assets/img/open-close.svg" alt="">
                                <span class="waiting-distribution">{{item.distributeIntentionCount}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="list" v-if="item.type == 'FLOW'||item.type == 'SMS'">
                        <div class="operation">
                            <span v-if="item.type == 'FLOW'" style='background:rgba(34, 215, 187, 0.1);color:rgba(34, 215, 187, 1)'>流程节点</span>
                            <span v-if="item.type == 'SMS'" style='background:rgba(202, 67, 226, 0.1);color:rgba(202, 67, 226, 1)'>短信节点</span>
                            <div v-if="item.coefficientType=='EXCELLENT'" style="color:rgba(30, 216, 255, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/excellent.svg" alt="">
                                <span>优秀</span>
                            </div>
                            <div v-if="item.coefficientType=='NORMAL'" style="color:rgba(53, 108, 255, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/normal.svg" alt="">
                                <span>正常</span>
                            </div>
                            <div v-if="item.coefficientType=='DOUBT'" style="color:rgba(255, 124, 26, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/doubt.svg" alt="">
                                <span>疑问</span>
                            </div>
                            <div v-if="item.coefficientType=='ANGER'" style="color:rgba(255, 0, 109, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/anger.svg" alt="">
                                <span>愤怒</span>
                            </div>
                            <div v-if="item.coefficientType=='COMPLAINT'" style="color:rgba(255, 95, 218, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/complaint.svg" alt="">
                                <span>负面</span>
                            </div>
                            <span style="color:rgba(204, 204, 204, 1);font-size:14px">最大次数：</span>
                            <span style="color:rgba(204, 204, 204, 1)">{{ item.maxTriggerCount }}</span>
                            <div class="right operation-list">
                                <a-icon class="arrow-up" @click="moveNodePlace(item.id, 1)" v-if="index!=1" type="arrow-up" />
                                <a-icon class="arrow-down" @click="moveNodePlace(item.id, 2)" v-if="index!=(nodeList.length-1)" type="arrow-down" />
                                <a-icon class="delete" type="delete" @click="confirm(item.id)"/>
                            </div>
                        </div>
                        <div class="area-edit">
                            <span class="serial-number">{{index+1}}</span>
                            <a-input style="font-weight:500" v-model='item.name' @blur="changeLinesName(item)" />
                            <!-- <a-icon class="add" type="diff" @click="addLines(null,item.id)"/> -->
                            <div class="add" @click="addLines(null,item.id)">
                                <span>添加台词</span>
                                <a-icon type="plus-circle"/>
                            </div>
                        </div>
                        <div class="area-list">
                            <div class="list-content" v-for="(talkingItem, talkingIndex) in item.talkingSkillList" :key="talkingIndex">
                                <a-textarea style="line-height:20px;height:65px;font-weight:500" @blur="addLines(talkingItem)" v-model='talkingItem.content' />
                                <!-- <a-icon type="minus-circle" @click="removeLines(talkingItem.id,item.id)"/> -->
                                <div class="remove-line" @click="removeLines(talkingItem.id,item.id)">
                                    <span>删除台词</span>
                                    <a-icon type="minus-circle"/>
                                </div>
                            </div>
                        </div>
                        <div class="distribution" style="width:100%">
                            <div class="up-down" v-if="!boolList[index]" @click='ifShow(index,item.id)' style='position:absolute;right:44px;bottom:0px'>
                                <span>{{item.unDistributeIntentionCount}}个回答待分配</span>
                                <!-- <a-icon type="down" /> -->
                                <img src="../../assets/img/open-close.svg" alt="">
                                <span class="waiting-distribution">{{item.distributeIntentionCount}}</span>
                            </div>
                            <div style="width:80%;padding-bottom:28px">
                                <div v-if="boolList[index]" class="gutter-example">
                                    <a-row :gutter="16">
                                        <a-col class="gutter-row" :span="12" style="max-height:600px;overflow-y:auto">
                                            <div class="gutter-box gutter-box1">
                                                <div class="distribution-text">
                                                    <span>待分配回答（意图）</span>
                                                    <a-button type="primary" @click="addNewIntention" style="float:right">
                                                        新增意图
                                                    </a-button>
                                                </div>
                                                <draggable element="span" v-model="item.unDistributeIntentionList" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" :move="onMove">
                                                    <transition-group type="transition" :name="'flip-list'" tag="ul" class="list-group">
                                                        <li class="idea list-group-item" v-for="(waitingItem, waitingIndex) in item.unDistributeIntentionList" :key="waitingIndex">
                                                            <div>
                                                                {{waitingItem.name}}
                                                                <a-icon @click="editAnswerWay(waitingItem.id)" type="edit" />
                                                                <span>答法：{{waitingItem.sampleCount}}</span>
                                                            </div>
                                                            <a-icon class="add move" type="drag" />
                                                        </li>
                                                    </transition-group>
                                                </draggable>
                                            </div>
                                        </a-col>
                                        <a-col class="gutter-row" :span="12" style="max-height:600px;overflow-y:auto">
                                            <div style="text-align:center;cursor:pointer;margin:10px 0 20px 0">
                                                <a-icon type="plus" />
                                                <span style='margin-left:5px' @click="addJumpLogic(item.id,index)">跳转逻辑</span>
                                            </div>
                                            <div v-if="testArr[index].state" style="min-height:80px;padding:8px;background:#f5f5f5;margin-bottom:10px;border: rgba(166, 166, 166, 1) dotted 1px;">
                                                <div class="add-point">
                                                    <a-select defaultValue="请选择" style="width: 80%" @change="handleChange2" @focus="queryNodeSelectList(null)">
                                                        <a-select-option :title="selectItem.name" :value="selectItem.id" v-for="(selectItem, selectIndex) in optionListData" :key="selectIndex">{{selectItem.name}}</a-select-option>
                                                    </a-select>
                                                    <a-icon @click="removeTemporaryNode" type="delete" style="float:right" />
                                                </div>
                                                <div>
                                                    <draggable element="span" v-model="testArr[index].data" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" @add="addIntention(index,false)">
                                                        <transition-group type="transition" :name="'flip-list'" tag="ul" class="list-group">
                                                            <div class="list-content" v-for="(talkingItem, talkingIndex) in testArr[index].data" :key="talkingIndex">
                                                                <span>{{talkingItem.name}}</span>
                                                                <a-icon class="move" type="drag"/>
                                                                <a-icon type="minus-circle" @click="removeLines(talkingItem.id)"/>
                                                            </div>
                                                        </transition-group>
                                                    </draggable>
                                                </div>
                                            </div>
                                            <div style="text-align:center" v-if="item.nextNodeList==0&&nodeDataList.length==0">
                                                <img style="width:100%" src="../../assets/img/moving.gif" alt="">
                                            </div>
                                            <div class="gutter-box gutter-box2" v-for="(allocateItem, allocateIndex) in item.nextNodeList" :key="allocateIndex">
                                                <div class="add-point">
                                                    <a-select :defaultValue="allocateItem.name" :key="allocateItem.name" style="width: 80%" @change="(e)=>handleChange1(e,allocateItem.id)" @focus="queryNodeSelectList(allocateItem.id)">
                                                        <a-select-option :title="selectItem.name" :value='selectItem.id' v-for="(selectItem, selectIndex) in optionListData" :key="selectIndex">{{selectItem.name}}</a-select-option>
                                                    </a-select>
                                                    <a-icon type="delete" style="float:right" @click="deleteNextNode(allocateItem.id)"/>
                                                </div>
                                                <div>
                                                    <draggable element="span" v-model="allocateItem.intentionList" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false" @add="addIntention(allocateItem,true)" :move="onMove">
                                                        <transition-group name="no" class="list-group" tag="ul">
                                                            <li class="list-group-item list-point" v-for="(desItem, desIndex) in allocateItem.intentionList" :key="desIndex">
                                                                <div>{{desItem.name}}</div>
                                                                <a-icon class="move" type="drag" />
                                                                <a-icon type="minus-circle" @click="deleteAssignedIntention(desItem.id)"/>
                                                            </li>
                                                        </transition-group>
                                                    </draggable>
                                                </div>
                                            </div>
                                        </a-col>
                                    </a-row>
                                </div>
                            </div>
                            <div class="up-down" v-if="boolList[index]" @click='ifShow(index,item.id)' style='position:absolute;right:44px;bottom:0px'>
                                <span>{{item.unDistributeIntentionCount}}个回答待分配</span>
                                <!-- <a-icon type="up" /> -->
                                <img src="../../assets/img/open-close.svg" alt="">
                                <span class="waiting-distribution">{{item.distributeIntentionCount}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="list" v-if="item.type == 'FINISH'||item.type == 'TRANSFER'">
                        <div class="operation">
                            <span v-if="item.type == 'FINISH'" style='background:rgba(250, 90, 85, 0.1);color:rgba(250, 90, 85, 1)'>结束节点</span>
                            <span v-if="item.type == 'TRANSFER'" style='background:rgba(255, 196, 66, 0.1);color:rgba(255, 196, 66, 1)'>转接节点</span>
                            <div v-if="item.coefficientType=='EXCELLENT'" style="color:rgba(30, 216, 255, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/excellent.svg" alt="">
                                <span>优秀</span>
                            </div>
                            <div v-if="item.coefficientType=='NORMAL'" style="color:rgba(53, 108, 255, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/normal.svg" alt="">
                                <span>正常</span>
                            </div>
                            <div v-if="item.coefficientType=='DOUBT'" style="color:rgba(255, 124, 26, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/doubt.svg" alt="">
                                <span>疑问</span>
                            </div>
                            <div v-if="item.coefficientType=='ANGER'" style="color:rgba(255, 0, 109, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/anger.svg" alt="">
                                <span>愤怒</span>
                            </div>
                            <div v-if="item.coefficientType=='COMPLAINT'" style="color:rgba(255, 95, 218, 1);display:inline-block;margin-right:16px;">
                                <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/complaint.svg" alt="">
                                <span>负面</span>
                            </div>
                            <span style="color:rgba(204, 204, 204, 1);font-size:14px">最大次数：</span>
                            <span style="color:rgba(204, 204, 204, 1)">{{ item.maxTriggerCount }}</span>
                            <div class="right operation-list">
                                <a-icon class="arrow-up" @click="moveNodePlace(item.id, 1)" v-if="index!=1" type="arrow-up" />
                                <a-icon class="arrow-down" @click="moveNodePlace(item.id, 2)" v-if="index!=(nodeList.length-1)" type="arrow-down" />
                                <a-icon class="delete" type="delete" @click="confirm(item.id)"/>
                            </div>
                        </div>
                        <div class="area-edit">
                            <span class="serial-number">{{index+1}}</span>
                            <a-input v-model='item.name' @blur="changeLinesName(item)" />
                            <!-- <a-icon class="add" type="diff" @click="addLines(null,item.id)"/> -->
                            <div class="add" @click="addLines(null,item.id)">
                                <span>添加台词</span>
                                <a-icon type="plus-circle"/>
                            </div>
                        </div>
                        <div class="area-list">
                            <div class="list-content" v-for="(talkingItem, talkingIndex) in item.talkingSkillList" :key="talkingIndex">
                                <a-textarea style="line-height:20px;height:65px" @blur="addLines(talkingItem)" v-model='talkingItem.content' />
                                <!-- <a-icon type="minus-circle" @click="removeLines(talkingItem.id,item.id)"/> -->
                                <div class="remove-line" @click="removeLines(talkingItem.id,item.id)">
                                    <span>删除台词</span>
                                    <a-icon type="minus-circle"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <a-icon v-if="!ifShowDetail" type="left-circle" style="position:fixed;right:5px;top:50%;color:rgba(204, 204, 204, 1);font-size:24px" @click="openDetail"/>
        <div class="detail" v-if="ifShowDetail">
            <a-icon v-if="ifShowDetail" type="right-circle" style="position:absolute;left:-12px;top:45%;color:rgba(204, 204, 204, 1);font-size:24px" @click="closeDetail"/>
            <div v-if="currentNodeId!=-1">
                <div class="title" style="padding-bottom:12px;border-bottom:1px solid rgba(240, 240, 240, 1);margin-bottom:24px">
                    <span>高级配置</span>
                </div>
                <div class="tags">
                    节点{{selectInfo.num}}
                    <span v-bind:style="{color:selectInfo.color}">[{{selectInfo.type}}]</span>
                </div>
                <div class="max-times">
                    <span>最大次数：</span>
                    <a-input-number style="width:120px" :min="0" :max="1000" v-model="maxTriggerCount" @change="onChange1" />
                </div>
                <div class="interrupt">
                    <span>能否打断：</span>
                    <a-radio-group v-model="canInterrupt" name="radioGroup" :default-value="canInterrupt" @change="onChange3">
                        <a-radio :value="true">
                        是
                        </a-radio>
                        <a-radio :value="false">
                        否
                        </a-radio>
                    </a-radio-group>
                </div>
                <div class="interrupt">
                    <span>节点情绪：</span>
                    <a-select :defaultValue='defaultSelectMood' v-model='defaultSelectMood' :key="defaultSelectMood" style="width: 190px" @change="onChangeMood">
                        <!-- <a-select-option :value=-1 title="空">空</a-select-option> -->
                        <a-select-option title='优秀' value='EXCELLENT'>
                            <span style="float:left;margin-right:4px;">优秀</span>
                            <img style="width:18px;float:left;margin-top:3px;margin-right:2px;" src="../../assets/img/excellent.svg" alt="">     
                        </a-select-option>
                        <a-select-option title='正常' value='NORMAL'>
                            <span style="float:left;margin-right:4px;">正常</span>
                            <img style="width:18px;float:left;margin-top:2px;margin-right:2px;" src="../../assets/img/normal.svg" alt="">     
                        </a-select-option>
                        <a-select-option title='疑问' value='DOUBT'>
                            <span style="float:left;margin-right:4px;">疑问</span>
                            <img style="width:18px;float:left;margin-top:2px;margin-right:2px;" src="../../assets/img/doubt.svg" alt="">  
                        </a-select-option>
                        <a-select-option title='愤怒' value='ANGER'>
                            <span style="float:left;margin-right:4px;">愤怒</span>
                            <img style="width:18px;float:left;margin-top:2px;margin-right:2px;" src="../../assets/img/anger.svg" alt="">  
                        </a-select-option>
                        <a-select-option title='负面' value='COMPLAINT'>
                            <span style="float:left;margin-right:4px;">负面</span>
                            <img style="width:18px;float:left;margin-top:2px;margin-right:2px;" src="../../assets/img/complaint.svg" alt="">  
                        </a-select-option>
                    </a-select>
                </div>
                <div class="interrupt" v-if="selectInfo.type != '结束节点'">
                    <span>默认路由：</span>
                    <a-select :defaultValue='defaultSelectNode' v-model='defaultSelectNode' :key="defaultSelectNode" style="width: 190px" @change="onChange5">
                        <a-select-option :value=-1 :key=-1 title="空">空</a-select-option>
                        <a-select-option :disabled="currentNodeId==item.id" :title='item.name' v-for="(item, index) in selectNodeList" :key="index" :value='item.id'>{{item.name.length>10?(item.name).substring(0,10)+'...':item.name}}</a-select-option>
                    </a-select>
                </div>
                <div style="margin-top:15px;display:flex" v-if="selectInfo.type == '转接节点'">
                    <span style="display:inline-block;width:78px">转接号码：</span>
                    <div style="flex:1">
                        <a-select style="width: 190px" v-model="transferNumberData" placeholder="请选择" @change="changeTransferNumber">
                            <a-select-option value='1'>
                                外部接口
                            </a-select-option>
                            <a-select-option value='2'>
                                机器人通道
                            </a-select-option>
                            <a-select-option value='3'>
                                手机号码
                            </a-select-option>
                            <a-select-option value='4'>
                                MPCC热线
                            </a-select-option>
                        </a-select>
                        <div class="number-list" v-if="transferNumberData==2||transferNumberData==4">
                            <ul>
                                <li v-for="(item,index) in numberList" :key='index'>
                                    <a-input @input='inputChange()' v-model="item.number" placeholder="请输入号码" />
                                    <a-icon v-if="index!=0" class="minus-icon" type="minus-circle" @click="minusNumber(index)" />
                                    <a-icon v-if="index==0" class="plus-icon" type="plus-circle" @click="plusNumber()" />
                                </li>
                            </ul>
                        </div>
                        <div v-if="transferNumberData==3" style="margin-top:8px;width:190px">
                            <a-textarea style="height:75px;" placeholder="转接手机号码涉及通话二次计费，请联系客服人员后台设定" disabled />
                        </div>
                        <div v-if="transferNumberData==1" style="margin-top:8px;width:190px">
                            <a-textarea @blur="changeSite" placeholder="请输入地址" allow-clear v-model="changeTransferSite" />
                        </div>
                    </div>

                </div>
                <div style="margin-top:15px" v-if="selectInfo.type == '短信节点'">
                    <a-textarea v-model="smsContent" placeholder="请输入需要发送的短信内容" :rows="4"  @blur="changeMsg" />
                </div>
                <div style="margin-top:24px;">
                    <a-button type="primary" style="float:right" @click="showRouter">
                        查看来源路由
                    </a-button>
                </div>
            </div>
            <div v-if="currentNodeId==-1" class="right-detail">
                <div style="border-bottom:1px solid rgba(240, 240, 240, 1);padding-bottom:12px">
                    <span style="color:rgba(80, 80, 80, 1);font-size:18px;">基本信息高级配置</span>
                </div>
                <!-- <div style="margin:16px 0;display:flex;">
                    <span style="color:rgba(153, 153, 153, 1);font-size:14px;display:inline-block;width:55px;">appid：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:12px;flex:1;margin-top:2px">{{basicInfo.appId}}</span>
                </div> -->
                <!-- <div style="display:flex;border-bottom:1px solid rgba(240, 240, 240, 1);padding-bottom:16px;margin-bottom:16px">
                    <span style="color:rgba(153, 153, 153, 1);font-size:14px;width:55px;">appkey：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:12px;flex:1;word-wrap: break-word;word-break: break-all;margin-top:2px;">{{basicInfo.appKey}}</span>
                </div> -->
                <!-- <div class="working-time-box" style="padding-bottom:16px;border-bottom:1px solid rgba(240, 240, 240, 1);margin-bottom:16px;margin-top:16px;">
                    <div style="color:rgba(80, 80, 80, 1);font-size:16px;">项目工作时间设定：</div>
                    <a-checkbox-group v-model="weekList" @change="chooseWorkingTime">
                        <a-row>
                            <a-col :span="6">
                                <a-checkbox value="MONDAY">
                                周一
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="TUESDAY">
                                周二
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="WEDNESDAY">
                                周三
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="THURSDAY">
                                周四
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="FRIDAY">
                                周五
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="SATURDAY">
                                周六
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="SUNDAY">
                                周日
                                </a-checkbox>
                            </a-col>
                        </a-row>
                    </a-checkbox-group>
                    <div style="margin:16px 0;color:rgba(153, 153, 153, 1);font-size:12px;">
                        <span>上午：</span>
                        <a-time-picker :disabledHours='getDisabledHours1' style='width:115px;' placeholder='开始时间' :default-value="moment(projectMorningTime.startTime, 'HH:mm')" format="HH:mm" @change="startTimeChange1"/>
                        <span style="margin:0 5px;">~</span>
                        <a-time-picker :disabledHours='getDisabledHours1' style='width:115px;' placeholder='结束时间' :default-value="moment(projectMorningTime.endTime, 'HH:mm')" format="HH:mm" @change="endTimeChange1"/>
                    </div>
                    <div style="color:rgba(153, 153, 153, 1);font-size:12px;">
                        <span>下午：</span>
                        <a-time-picker :disabledHours='getDisabledHours2' style='width:115px;' placeholder='开始时间' :default-value="moment(projectAfternoonTime.startTime, 'HH:mm')" format="HH:mm" @change="startTimeChange2"/>
                        <span style="margin:0 5px;">~</span>
                        <a-time-picker :disabledHours='getDisabledHours2' style='width:115px;' placeholder='结束时间' :default-value="moment(projectAfternoonTime.endTime, 'HH:mm')" format="HH:mm" @change="endTimeChange2"/>
                    </div>
                </div> -->
                <div style="color:rgba(80, 80, 80, 1);font-size:16px;margin-top:16px;">语音合成试听</div>
                <div style="margin-top:8px;">
                    <span style="font-size:14px;color:rgba(153, 153, 153, 1)">当前配置：</span>
                    <span style="font-size:12px;color:rgba(80, 80, 80, 1)">{{currentSelection}}</span>
                </div>
                <div style="width: 100%;display:flex;margin-top:16px;" class="voice-tab">
                    <div style="width:64px" class="select-list">
                        <div v-for="(item, index) in voiceDataList" :key="index" :class="{'active':currentVoiceType==item.type}" @click="chooseVoice(item.type)">
                            {{item.type}}
                        </div>
                    </div>
                    <div style="flex:1" class="voice-option">
                        <div style="margin-top:25px;" v-for="(item, index) in voiceDataList" :key="index">
                            <div v-if="currentVoiceType==item.type">
                                <div :class="{'active':currentVoicePerson==item2.value}" style="cursor:pointer;float:left;width:180px;margin:0 13px 10px;border-radius:4px;padding:5px 0" v-for="(item2, index2) in item.voiceList" :key="index2" @click="selectCurrentPerson(item2.value,item2.name)">
                                    <img style="width:24px;border-radius:12px;height:24px;margin-left:5px;float:left" :src='item2.avatar' alt="">
                                    <span style="margin-left:5px;float:left;margin-top:3px;">{{item2.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top:16px;border-radius:4px;overflow:hidden">
                    <div @click="tryListen" style="height:34px;line-height:34px;background:rgba(34, 215, 187, 1);color:#fff;font-size:14px;padding-left:12px;cursor:pointer">
                        <a-icon type="customer-service" />
                        <span style="margin-left:6px;">播放试听</span>
                    </div>
                    <a-textarea v-model="lineContent" placeholder="此处为播放tts常量文本区域" style="width:100%;height:80px;"/>
                </div>
                <div style="color:rgba(153, 153, 153, 1);font-size:14px;margin-top:16px;">阅读速度：</div>
                <div style="display:flex">
                    <a-slider v-model="speechRate" :min="-500" :max="500" style="flex:1"/>
                    <span style="display:inline-block;width:50px;text-align:center;margin-top:7px;">{{speechRate}}%</span>
                </div>
                <div style="text-align:left;margin-top:24px;">
                    <span style="display:inline-block;width:80px;height:32px;line-height:32px;text-align:center;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);font-size:14px;margin-right:16px;border-radius:4px;cursor:pointer">取消</span>
                    <span @click="application" style="display:inline-block;width:80px;height:32px;line-height:32px;text-align:center;border:1px solid rgba(34, 215, 187, 1);color:#fff;font-size:14px;margin-right:16px;background:rgba(34, 215, 187, 1);border-radius:4px;cursor:pointer">应用</span>
                </div>
                <!-- <a-divider />
                <div style="color:rgba(80, 80, 80, 1);font-size:16px;">脏字符统计</div>
                <div style="margin-top:16px;">
                    <span style="color:rgba(153, 153, 153, 1);font-size:14px;">脏字符数量：</span>
                    <span @click="showDirtyText" style="color:rgba(34, 215, 187, 1);font-size:14px;cursor:pointer">120条</span>
                </div> -->
            </div>
            <audio style="display:none" controls autoplay :src="voiceUrl"></audio>
        </div>
        <a-icon v-if="loadingState" style="position:fixed;left:50%;top:50%;color:#22d7bb;font-size:24px;z-index:10000" type="loading" />
        <a-modal
            title="脏字符详情"
            :visible="showDirtyVisiable"
            :footer="null"
            width='540px'
            @cancel="offDirtyModal"
        >
            <div style="color:rgba(51, 51, 51, 1);font-size:16px;">{{projectName}}</div>
            <a-textarea v-model="dirtyText" placeholder="此处为脏字符内容" style="width:100%;height:200px;margin-top:16px;overflow:auto"/>
            <div style="color:rgba(183, 183, 183, 1);font-size:12px;margin-top:16px;">
                <div>关于脏字符：</div>
                <div>
                在语音交互过程中，用户端的背景噪音或嘈杂环境，会引起语音识别到异常文字；例如：了，的，么这类；将此类字符添加到此处，在交互过程中，如果出现相同异常字符，则AI会忽略，不进行交互，直到用户返回真实的内容；
                </div>
                <div>您可以通过对话纠错页面添加脏字符；您也可以在此处手工增加或减少脏字符,每行代表一组脏字符。</div>
            </div>
            <div style="margin-top:16px;text-align:center">
                <span @click="saveDirtyText" style="display:inline-block;width:88px;height:34px;font-size:14px;border-radius:4px;color:#fff;background:rgba(34, 215, 187, 1);text-align:center;line-height:34px;margin:0 auto;box-shadow: 0px 4px 4px 0px rgba(34, 215, 187, 0.2);cursor:pointer">保存</span>
            </div>
        </a-modal>
        <a-modal
            title="来源路由"
            :visible="routerVisible"
            :footer="null"
            width='1230px'
            @cancel="offRouterModal"
        >
            <div style="max-height:600px;overflow-y:auto">
                <div style="height:35px;line-height:35px;background:#F0F0F0">
                    <span style="display:inline-block;width:15%;padding-left:16px;">节点类型</span>
                    <span style="display:inline-block;width:25%">上级节点名称</span>
                    <span style="display:inline-block;width:15%">路由策略</span>
                    <span style="display:inline-block;width:45%">意图集</span>
                </div>
                <div v-for="(item, index) in routerDataList" :key="index" style="height:35px;line-height:35px;">
                    <span style="display:inline-block;width:15%;padding-left:16px;">{{item.nodeType=='DISPERSED'?'离散节点':'流程节点'}}</span>
                    <span style="display:inline-block;width:25%">{{item.nodeName}}</span>
                    <span style="display:inline-block;width:15%">{{diffType(item.routeType)}}</span>
                    <span style="display:inline-block;width:45%">{{item.intentions==null?'--':item.intentions}}</span>
                </div>
            </div>
        </a-modal>
        <a-modal
            title="新增意图"
            :visible="newIntentionModal"
            :footer="null"
            width='480px'
            @cancel="offNewIntentionModal"
        >
            <div class="new-intention-modal">
                <div class="intention-name">
                    <span>意图名称：</span>
                    <a-input v-model="intentionName" placeholder="请输入意图名称" />
                </div>
                <div class="btn-group">
                    <a-button @click="sureAddIntention" type="primary">
                    确认
                    </a-button>
                    <a-button @click="offNewIntentionModal">取消</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal
            title="答法（样本）列表"
            :visible="sampleModal"
            :footer="null"
            width='600px'
            @cancel="offAnswerWayModal"
        >
            <div class="answer-way-modal">
                <a-textarea
                    style="height:200px;resize:none;"
                    placeholder="请输入新增样本"
                    v-model="newSample"
                />
                <div class="btn-group">
                    <a-button @click="sureAnswerWay" type="primary">
                    确认
                    </a-button>
                    <a-button @click="offAnswerWayModal">取消</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import moment from 'moment';
import draggable from "vuedraggable";
export default {
    name: 'EditLanguage',
    props: {
        msg: String,
    },
    components: {
      draggable
    },
    data() {
        return {
            isDragging: false,
            delayedDragging: false,
            ifShowData: true,
            projectId: '',
            nodeList: [],
            ifShowDetail: false,
            maxTriggerCount: null,
            canInterrupt: null,
            currentNodeId: '',
            selectNodeList: [],
            defaultSelectNode: null,
            proDes: '',
            projectName: '',
            senceList: [],
            proDetail: '',
            proSenceId: '',
            boolList: [],
            selectCurrentIndex: null,
            testArr: [],
            testArrOrigin: [],
            nextNodeId: '',
            optionListData: [],
            nodeDataList: [],
            currentDragElement: '',
            lastUpdateTime: '',
            selectInfo: {
                type: '',
                color: '',
                num: '',
                bgcolor: ''
            },
            smsContent: '',
            currentVoiceType: 'currency',
            percent: 0,
            currentVoicePerson: '',
            lineContent: '新鲜的微风吹动我的衣袂，如同爱人的鼻息吹着我的手一样。',
            voiceUrl: '',
            currentSelection: '',
            showDirtyVisiable: false,
            dirtyText: '',
            speechRate: 0,
            basicInfo: {},
            voiceDataList: [],
            currentPersonId: '',
            routerVisible: false,
            routerDataList: [],
            projectMorningTime: {
                startTime: '',
                endTime: ''
            },
            projectAfternoonTime: {
                startTime: '',
                endTime: ''
            },
            defaultSelectMood: '',
            weekList: [],
            transferNum: '',
            newIntentionModal: false,
            sampleModal: false,
            training: false,
            trainedCount: 0,
            unTrainedCount: 0,
            intentionName: '',
            currentIntentionId: '',
            newSample: '',
            channelCount: 0,
            numberList: [],
            transferNumberData: undefined,
            loadingState: false,
            timer: null,
            transferData: null,
            changeTransferSite: null,
        }; 
    },
    methods: {
        moment,
        onChangeMood(value) {
            this.axios.post('/api/project/node/coefficientType', {
                id: this.currentNodeId,
                coefficientType: value
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        // startTimeChange1(time, timeString) {
        //     this.projectMorningTime.startTime = timeString
        // },
        // endTimeChange1(time, timeString) {
        //     this.projectMorningTime.endTime = timeString
        // },
        // startTimeChange2(time, timeString) {
        //     this.projectAfternoonTime.startTime = timeString
        // },
        // endTimeChange2(time, timeString) {
        //     this.projectAfternoonTime.endTime = timeString
        // },
        onMove(evt) {
            this.currentDragElement = evt.draggedContext.element
        },
        onChange1(value) {
            this.maxTriggerCount = value
            this.axios.post('/api/project/node/maxTriggerCount', {
                id: this.currentNodeId,
                maxTriggerCount: value
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onChange3(e) {
            this.canInterrupt = e.target.value
            this.axios.post('/api/project/node/canInterrupt', {
                id: this.currentNodeId,
                canInterrupt: this.canInterrupt==true?true:false
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onChange5(value) {
            this.axios.post('/api/project/node/defaultRedirect', {
                id: this.currentNodeId,
                redirectNodeId: value
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        addPoint(type) {
            let nodeName = ''
            if(type == 'FLOW'){
                nodeName = '流程节点'
            }else if(type == 'SMS'){
                nodeName = '短信节点'
            }else if(type == 'TRANSFER'){
                nodeName = '转接节点'
            }else if(type == 'FINISH'){
                nodeName = '结束节点'
            }
            this.$confirm({
                title: '提示',
                content: '确定要新增'+nodeName+'吗？',
                okText: '确定',
                cancelText: '取消',
                icon: 'exclamation-circle',
                onOk: ()=> {
                    this.newNode(type)
                },
            })
        },
        newNode(type) {
            this.axios.post('/api/project/node', {
                projectId: this.projectId,
                nodeType: type
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData('addPoint')
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        ifShow(index,id) {
            if(id != this.currentNodeId){
                return false
            }
            setTimeout(()=>{
                this.boolList[index] = !this.boolList[index]
                this.$forceUpdate()
            },50)
        },
        queryNodeData(type) {
            this.axios( 
                {
                    method:'get',
                    url:'/api/project/node/list', 
                    params: {
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    if(type == "addPoint"){
                        this.selectCurrentIndex = response.data.data.length - 1
                        this.selectCurrentItem(response.data.data[this.selectCurrentIndex],this.selectCurrentIndex,'node')
                        this.scrollTopCon()
                    }
                    this.nodeList = response.data.data
                    this.testArr = []
                    this.testArrOrigin = []
                    for(let i = 0; i < this.nodeList.length; i++){
                        this.boolList.push(false)
                        let obj = {}
                        obj.name = ''
                        obj.id = ''
                        obj.state = false
                        obj.data = []
                        this.testArr.push(obj)
                        this.testArrOrigin.push(obj)
                    }
                    if(type == 'orderUp'){
                        this.selectCurrentIndex--
                    }else if(type == 'orderDown'){
                        this.selectCurrentIndex++
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        handleChange1(selectId,preId) {
            this.axios.post('/api/project/node/nextNode/update', {
                projectId: this.projectId,
                nodeId: this.currentNodeId,
                originNextNodeId: preId,
                afterNextNodeId: selectId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        addIntention(value, type) {
            if(type == false){
                if(this.nodeDataList[this.nodeDataList.length-1].id == ''){
                    this.$message.error('请先选择节点');
                    this.queryNodeData()
                }else{
                    this.nextNodeId = this.nodeDataList[this.nodeDataList.length-1].id
                    this.distributeIntention('new')
                }
            }else{
                this.nextNodeId = value.id
                this.distributeIntention(this.currentDragElement)
            }
        },
        handleChange2(value) {
            this.nodeDataList[this.nodeDataList.length-1].id = value
        },
        selectCurrentItem(item,index,type) {
            if(type == 'node'){
                this.selectInfo.num = index + 1
                switch(item.type) {
                    case 'START':
                        this.selectInfo.type = '开始节点'
                        this.selectInfo.color = 'rgb(78, 138, 250)'
                        this.selectInfo.bgcolor = 'rgb(237, 243, 254)'
                        break;
                    case 'FINISH':
                        this.selectInfo.type = '结束节点'
                        this.selectInfo.color = 'rgb(250, 90, 85)'
                        this.selectInfo.bgcolor = 'rgba(250, 90, 85, 0.1)'
                        break;
                    case 'FLOW':
                        this.selectInfo.type = '流程节点'
                        this.selectInfo.color = 'rgb(34, 215, 187)'
                        this.selectInfo.bgcolor = 'rgba(34, 215, 187, 0.1)'
                        break;
                    case 'SMS':
                        this.selectInfo.type = '短信节点'
                        this.selectInfo.color = 'rgb(202, 67, 226)'
                        this.selectInfo.bgcolor = 'rgba(202, 67, 226, 0.1)'
                        break;
                    case 'TRANSFER':
                        this.selectInfo.type = '转接节点'
                        this.selectInfo.color = 'rgb(255, 196, 66)'
                        this.selectInfo.bgcolor = 'rgba(255, 196, 66, 0.1)'
                        this.transferNum = item.transferNum
                        if(item.transferNum != ''){
                            let data = eval("(" + item.transferNum + ")")
                            this.transferNumberData = data.type
                            if(data.type == '1'){
                                this.changeTransferSite = data.url
                            }else{
                                this.numberList = data.list
                            }
                            this.$forceUpdate()
                        }
                        break;
                } 
                if(this.currentNodeId != item.id){
                    this.maxTriggerCount = item.maxTriggerCount
                    this.canInterrupt = item.canInterrupt
                    this.currentNodeId = item.id
                    this.defaultSelectNode = item.defaultRedirectNodeId
                    this.selectCurrentIndex = index
                    this.nodeDataList = []//初始化即将被分配节点信息槽
                    this.smsContent = item.smsContent
                    this.defaultSelectMood = item.coefficientType
                    for(let i = 0; i < this.testArr.length; i++){
                        this.testArr[i].state = false
                        this.boolList[i] = false
                    }
                }
            }else{
                this.selectCurrentIndex = -1
                this.currentNodeId = -1
                for(let i = 0; i < this.testArr.length; i++){
                    this.testArr[i].state = false
                    this.boolList[i] = false
                }
            }
            
        },
        addJumpLogic(id,index) {
            this.nodeDataList = []
            this.testArr[index].state = true
            let obj = {}
            obj.id = ''
            this.nodeDataList.push(obj)
        },
        querySelectNode() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/dropdown/node', 
                    params: {
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.selectNodeList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        getLength(str) {
            let realLength = 0, len = str.length, charCode = -1;
            for (let i = 0; i < len; i++) {
                charCode = str.charCodeAt(i);
                if (charCode >= 0 && charCode <= 128) realLength += 1;
                else realLength += 2;
            }
            return realLength
        },
        addLines(item,id) {
            let itemId = '', itemContent = ''
            if(item != null){
                itemId = item.id
                itemContent = (item.content).replace(/\s/g,"")
            }else{
                if(id != this.currentNodeId){
                    return false
                }
            }
            if(this.getLength(itemContent) > 2000){
                this.$message.error('台词内容太多，无法解析。请删减');
            }else{
                this.loadingState = true
                this.axios.post('/api/talkingSkill', {
                    id: itemId,
                    projectId: this.projectId,
                    nodeId: this.currentNodeId,
                    content: itemContent
                })
                .then(response=> {
                    this.loadingState = false
                    if(response.data.code == 0){
                        if(item == null){
                            this.queryNodeData()
                        }else{
                            this.$message.success('修改成功')
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }
        },
        removeLines(talkingId,itemId) {
            if(itemId != this.currentNodeId){
                return false
            }
            this.axios.post('/api/talkingSkill/delete', {
                id: talkingId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        changeProName() {
            this.axios.post('/api/project/name', {
                id: this.projectId,
                name: this.projectName
            })
            .then(response=> {
                if(response.data.code != 0){
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        changeProDes() {
            this.axios.post('/api/project/description', {
                id: this.projectId,
                description: this.proDes
            })
            .then(response=> {
                if(response.data.code != 0){
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        trim(s){
            return s.replace(/(^\s*)|(\s*$)/g, "");
        },
        changeLinesName(item) {
            if(this.trim(item.name).length > 0){
                this.axios.post('/api/project/node/name', {
                    id: item.id,
                    name: item.name
                })
                .then(response=> {
                    if(response.data.code != 0){
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }else{
                this.$message.error('名称不能为空');
                this.queryNodeData()
            }
        },
        querySenceList() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/dropdown/scene', 
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.senceList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryProDetail() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/project', 
                    params: {
                        id: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.proDetail = response.data.data
                    this.proSenceId = response.data.data.sceneId
                    this.projectName = response.data.data.name
                    this.proDes = response.data.data.description
                    this.lastUpdateTime = response.data.data.lastPushTime
                    this.channelCount = response.data.data.channelCount
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        selectSence(value) {
            this.axios.post('/api/project/scene', {
                id: this.projectId,
                sceneId: value
            })
            .then(response=> {
                if(response.data.code != 0){
                   this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        deleteNextNode(id) {
            this.axios.post('/api/project/node/nextNode/delete', {
                projectId: this.projectId,
                nodeId: this.currentNodeId,
                nextNodeId: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                    this.nodeDataList = []
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        deleteAssignedIntention(id) {
            this.axios.post('/api/project/node/intention/delete', {
                projectId: this.projectId,
                nodeId: this.currentNodeId,
                intentionId: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                    this.nodeDataList = []
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        distributeIntention(type){
            let intentionId = ''
            if(type == 'new'){
                for(let i = 0; i < this.testArr.length; i++){
                    if(this.testArr[i].state){
                        intentionId = this.testArr[i].data[0].id
                    }
                }
            }else{
                intentionId = type.id
            }
            if(intentionId != ''){
                this.axios.post('/api/project/node/intention/distribute', {
                    projectId: this.projectId,
                    nodeId: this.currentNodeId,
                    intentionId: intentionId,
                    nextNodeId: this.nextNodeId,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryNodeData()
                    }else{
                        this.queryNodeData()
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            } 
        },
        queryNodeSelectList(value) {
            let currentNodeValue = ''
            if(value != null){
                currentNodeValue = value
            }
            this.axios(
                {
                    method:'get',
                    url:'/api/dropdown/nextNode',
                    params: {
                        projectId: this.projectId,
                        preNodeId: this.currentNodeId,
                        currentNodeId: currentNodeValue,
                    }
                })
            .then(response=> {
                if(response.data.code == 0){
                    this.optionListData =  response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        changeNextNodeId() {
            this.axios.post('/api/project/node/nextNode/update', {
                projectId: this.projectId,
                nodeId: this.currentNodeId,
                originNextNodeId: '',
                afterNextNodeId: '',
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        applicationUse() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/project/train', 
                    params: {
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('应用配置成功');
                    this.queryProDetail()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        removeTemporaryNode() {
            for(let i = 0; i < this.testArr.length; i++){
                this.testArr[i].state = false
            }
            this.nodeDataList = []
        },
        moveNodePlace(id, direction) {
            if(id != this.currentNodeId){
                return false
            }
            this.axios.post('/api/project/node/orderNo', {
                id: id,
                direction: direction,
            })
            .then(response=> {
                if(response.data.code == 0){
                    if(direction==1){
                        this.queryNodeData('orderUp')
                    }else{
                        this.queryNodeData('orderDown')
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        confirm(id) {
            if(id != this.currentNodeId){
                return false
            }
            this.$confirm({
                title: '提示',
                content: '确定要删除吗？',
                okText: '确定',
                cancelText: '取消',
                icon: 'warning',
                onOk: ()=> {
                    this.removeNode(id)
                },
            })
        },
        removeNode(id) {
            this.axios.post('/api/project/node/delete', {
                id: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        closeDetail() {
            this.ifShowDetail = false
        },
        openDetail() {
            if(this.currentNodeId != ""){
                this.ifShowDetail = true 
            }
        },
        scrollTopCon() {
            this.$nextTick(function() {
                let div = document.getElementById('chatDiv');
                div.scrollTop = div.scrollHeight;
            })
        },
        changeMsg() {
            this.smsContent = this.trim(this.smsContent)
            this.axios.post('/api/project/node/smsContent', {
                id: this.currentNodeId,
                smsContent: this.smsContent
            })
            .then(response=> {
                if(response.data.code != 0){
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        chooseVoice(type) {
            this.currentVoiceType = type
        },
        increase() {
            let percent = this.percent + 10;
            if (percent > 100) {
                percent = 100;
            }
            this.percent = percent;
        },
        decline() {
            let percent = this.percent - 10;
            if (percent < 0) {
                percent = 0;
            }
            this.percent = percent;
        },
        selectCurrentPerson(type,voice) {
            this.currentVoicePerson = type
            this.currentSelection = voice
            this.currentPersonId = type
        },
        tryListen() {
            this.voiceUrl = 'http://47.111.165.100:8005/tts?text='+this.lineContent+'&format=wav&speaker=47&voice='+this.currentVoicePerson+'&speechRate='+this.speechRate+'&timestamp='+(new Date()).getTime()
        },
        showDirtyText() {
            this.showDirtyVisiable = true
        },
        offDirtyModal() {
            this.showDirtyVisiable = false
        },
        saveDirtyText() {
            this.showDirtyVisiable = false
        },
        queryProBasicInfo() {
            this.axios(
                {
                    method:'get',
                    url:'/api/project/advance', 
                    params: {
                        projectId: this.projectId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.basicInfo = response.data.data
                    this.currentSelection = response.data.data.ttsVoiceName
                    this.speechRate = response.data.data.voiceSpeed
                    this.currentVoicePerson = response.data.data.ttsVoice
                    // this.projectMorningTime.startTime = response.data.data.morningTime.startTime==''?'09:00':response.data.data.morningTime.startTime
                    // this.projectMorningTime.endTime = response.data.data.morningTime.endTime==''?'11:30':response.data.data.morningTime.endTime
                    // this.projectAfternoonTime.startTime = response.data.data.afternoonTime.startTime==''?'13:30':response.data.data.afternoonTime.startTime
                    // this.projectAfternoonTime.endTime = response.data.data.afternoonTime.endTime==''?'17:30':response.data.data.afternoonTime.endTime
                    this.currentPersonId = response.data.data.ttsVoice
                    // this.weekList = response.data.data.weekList
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryVoiceList() {
            this.axios.get('/api/ttsVoiceConfig/list')
            .then(response=> {
                if(response.data.code == 0){
                    this.voiceDataList = response.data.data
                    this.currentVoiceType = response.data.data[0].type
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        application() {
            if(this.currentPersonId == ''){
                this.$message.error('请先选择配音对象');
            }else{
                this.axios.post('/api/project/advance', {
                    id: this.projectId,
                    ttsVoice: this.currentPersonId,
                    voiceSpeed: this.speechRate,
                    // weekList: this.weekList,
                    // morningTime: {
                    //     startTime: this.projectMorningTime.startTime,
                    //     endTime: this.projectMorningTime.endTime
                    // },
                    // afternoonTime: {
                    //     startTime: this.projectAfternoonTime.startTime,
                    //     endTime: this.projectAfternoonTime.endTime,
                    // }
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('配置成功');
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }
        },
        showRouter() {
            this.routerVisible = true
            this.axios(
                {
                    method:'get',
                    url:'/api/project/node/route/list', 
                    params: {
                        id: this.currentNodeId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.routerDataList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        offRouterModal() {
            this.routerVisible = false
        },
        diffType(type) {
            switch(type) {
                case '':
                    return '--'
                case 'INTENTION':
                    return '意图'
                case 'DEFAULT':
                    return '默认'
            } 
        },
        addNewIntention() {
            this.intentionName = ''
            this.newIntentionModal = true
        },
        offNewIntentionModal() {
            this.newIntentionModal = false
        },
        sureAddIntention() {
            this.newIntentionModal = false
            this.axios.post('/api/intention', {
                id: '',
                name: this.intentionName,
                projectId: this.projectId
            })
            .then(response=> {
                this.intentionModal = false
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        editAnswerWay(id) {
            this.newSample = ''
            this.sampleModal = true
            this.currentIntentionId = id
        },
        sureAnswerWay() {
            this.sampleModal = false
            this.axios.post('/api/intention/sample', {
                intentionId: this.currentIntentionId,
                content: this.newSample
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        offAnswerWayModal() {
            this.sampleModal = false
        },
        // chooseWorkingTime(value) {
        //     this.weekList = value
        // },
        // getDisabledHours1 () {
        //     return [12,13,14,15,16,17,18,19,20,21,22,23]
        // },
        // getDisabledHours2 () {
        //     return [0,1,2,3,4,5,6,7,8,9,10,11]
        // },
        startTrain() {
            this.training = true
            this.axios.post('/api/intention/train', {
                projectId: this.projectId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('训练成功');
                    this.queryTrainSample()
                }else{
                    this.training = false
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                this.training = false
                console.log(error)
            })
        },
        queryTrainSample() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/intention/statistic', 
                    params: {
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.trainedCount = response.data.data.trainedCount
                    this.unTrainedCount = response.data.data.unTrainedCount
                    this.training = (response.data.data.trainStatus=='TRAINING'?true:false)
                }else{
                    this.$message.error(response.data.message);
                    this.training = false
                }
            })
            .catch(error=> {
                this.training = false
                console.log(error)
            }) 
        },
        bindPath() {
            this.$router.push("/Account/PathManage")
        },
        changeTransferNumber() {
            this.numberList = [
                {
                    number: ''
                }
            ]
        },
        minusNumber(index) {
            this.numberList.splice(index, 1)
            this.changeData()
        },
        plusNumber() {
            let obj = {
                number: ''
            }
            this.numberList.push(obj)
        },
        inputChange() {
            clearTimeout(this.timer); // 清除未执行的代码，重置回初始化状态
            this.timer = setTimeout(()=>{
                this.changeData()
            },1500)
        },
        changeData() {
            let parse = JSON.stringify({
                type: this.transferNumberData,
                list: this.numberList
            })
            this.axios.post('/api/project/node/transferNum', {
                id: this.currentNodeId,
                transferNum: parse
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                    this.$message.success('转接号码设置成功');
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        changeSite() {
            let parse = JSON.stringify({
                type: this.transferNumberData,
                url: this.changeTransferSite
            })
            this.axios.post('/api/project/node/transferNum', {
                id: this.currentNodeId,
                transferNum: parse
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryNodeData()
                    this.$message.success('转接号码设置成功');
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                ghostClass: "ghost"
            };
        },
    },
    watch: {
        isDragging(newValue) {
            if (newValue) {
                this.delayedDragging = true;
                return;
            }
            this.$nextTick(() => {
                this.delayedDragging = false;
            });
        },
    },
    mounted: function() {
        this.sessionData('set','contentNavItem','edit');
        this.projectId = this.$route.query.projectId
        this.queryProDetail()
        this.querySelectNode()
        this.queryNodeData()
        this.querySenceList()
        this.queryProBasicInfo()
        this.queryVoiceList()
        this.queryTrainSample()
    }
}
</script>

<style scoped  lang="less">
    .ant-select-selection__rendered img{
        margin-top: 6px !important;
    }
    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0.5s;
    }
    .edit-language{
        height: 100%;
        input{
            border-color:rgba(238, 238, 238, 1);
        }
        textarea{
            border-color:rgba(238, 238, 238, 1);
        }
        select{
            border-color:rgba(238, 238, 238, 1);
        }
        i{
            cursor: pointer;
        }
        i.move{
            cursor: move;
        }
        i:hover{
            color: #2672FF;
        }
        .right{
            float: right;
        }
        .left{
            float: left;
        }
        background: #F5F5F5;
        padding: 24px 0 24px 24px;
        .new-point{
            width: 240px;
            height: 100%;
            position: fixed;
            left:64px;
            background-color: #fff;
            color: #fff;
            font-size: 14px;
            padding-bottom: 48px;
            .point-list{
                position: relative;
                height: 100%;
                width: 100%;
                li{
                    height: 48px;
                    padding-left:24px;
                    line-height: 48px;
                    font-size: 14px;
                    color: rgba(80, 80, 80, 1);
                    cursor: pointer;
                }
                li:hover{
                    background: rgba(34, 215, 187, 0.1);
                    i{
                        color: rgba(34, 215, 187, 1);
                    }
                }
                .path-bind{
                    position: absolute;
                    bottom: 16px;
                    left: 0px;
                    left: 16px;
                    font-size: 14px;
                    div{
                        color: rgba(18, 18, 18, 1);
                    }
                    button{
                        margin-top: 8px;
                        color: #fff;
                    }
                }
            }
        }
        .content{
            height: 100%;
            overflow-y: auto;
            padding: 0 24px 60px 240px;
            .title{
                width: 100%;
                background: #fff;
                padding: 24px;
                input{
                    height: 32px;
                    border: 1px solid rgba(238, 238, 238, 1);
                    line-height: 32px;
                    color: #000;
                    display: block;
                    text-align: center;
                    font-size: 16px;
                }
                textarea{
                    min-height: 32px;
                    border: 1px solid rgba(238, 238, 238, 1);
                    line-height: 32px;
                    color: #000;
                    display: block;
                    font-size: 12px;
                }
            }
            .title.active{
                border: 2px dotted #22d7bb;
            }
            .area{
                i:hover{
                    color: rgba(34, 215, 187, 1);
                }
                div.active{
                    border: 2px dotted #22d7bb;
                }
                .list{
                    background: #fff;
                    padding: 24px;
                    border-radius: 4px;
                    min-height: 146px;
                    .up-down{
                        color: rgba(158, 172, 196, 1);
                        font-size: 14px;
                        cursor: pointer;
                        position: relative;
                        img{
                            width: 18px;
                            margin-left: 4px;
                        }
                        .waiting-distribution{
                            display: inline-block;
                            border-radius: 9px;
                            height: 18px;
                            min-width: 24px;
                            padding: 0 3px;
                            text-align: center;
                            line-height: 18px;
                            font-size: 12px;
                            color: #fff;
                            position: absolute;
                            right: -22px;
                            top: -10px;
                            background: rgba(245, 87, 78, 1);
                        }
                    }
                    .operation{
                        span{
                            display: inline-block;
                            text-align: center;
                            line-height: 24px;
                        }
                        span:nth-child(1){
                            margin-right: 18px;
                            width: 70px;
                            height: 24px;
                            margin-left:30px;
                        }
                        .operation-list{
                            display: none;
                            i{
                                margin-right: 15px;
                                font-size: 20px;
                            }
                            i.arrow-up:hover{
                                color: rgba(34, 215, 187, 1) !important;
                            }
                            i.arrow-down:hover{
                                color: rgba(34, 215, 187, 1) !important;
                            }
                            i.delete:hover{
                                color: rgba(255, 141, 26, 1) !important;
                            }
                        }
                    }
                }
                .list:hover{
                    .operation-list{
                        display: inline-block;
                    }
                }
                .area-edit{
                    margin-top: 18px;
                    .serial-number{
                        display: inline-block;
                        width: 30px;
                        height: 30px;
                        line-height: 30px;
                        font-size: 12px;
                        color: rgba(80, 80, 80, 1);
                    }
                    input{
                        width: 80%;
                    }
                    .add{
                        display: none;
                        margin-left: 10px;
                        cursor: pointer;
                        color: rgba(34, 215, 187, 1);
                        i{
                            font-size: 20px;
                            float: left;
                        }
                        span{
                            font-size: 12px;
                            margin-left: 4px;
                        }
                    }
                }
                .area-list{
                    .list-content{
                        margin-top: 12px;
                        textarea{
                            width: 80%;
                            margin-left: 30px;
                            margin-right: 12px;
                            resize:none;
                        }
                        .remove-line{
                            display: none;
                            color: rgba(255, 87, 51, 1);
                            cursor: pointer;
                            i{
                                margin-right: 4px;
                                font-size: 20px;
                                float: left;
                            }
                        }
                    }
                }
                .distribution{
                    width: 80%;
                    position: relative;
                    margin-left: 30px;
                    margin-top: 24px;
                    .gutter-example .ant-row > div {
                        background: transparent;
                        border: 0;
                    }
                    .gutter-box {
                        color: rgba(80, 80, 80, 1);
                        background-color: rgba(245, 245, 245, 1);
                        padding: 16px;
                        font-size: 12px;
                        // border: rgba(166, 166, 166, 1) dotted 1px;
                        margin-bottom: 8px;
                        .list-group-item{
                            div{
                                background: #fff;
                                padding: 6px 10px;
                                border: 1px dotted #888;
                                display: inline-block;
                                width: 80%;
                                i{
                                    float: right; 
                                    color: rgba(0, 186, 173, 1);
                                    font-size: 12px;
                                    margin-top: 4px;
                                    margin-left: 8px;
                                    cursor: pointer;
                                }
                                span{
                                    float: right;  
                                    color: rgba(0, 186, 173, 1);
                                    font-size: 12px;
                                };
                            }
                        }
                    }
                    .gutter-box1{
                        padding-bottom: 50px;
                        .distribution-text{
                            margin-bottom: 11px;
                            text-align: center;
                            button{
                                height: 22px;
                                padding: 0 8px;
                                font-size: 12px;
                            }
                        }
                        .idea{
                            margin-bottom: 2px;
                            input{
                                width: 80%;
                                border:rgba(166, 166, 166, 1) dotted 1px;
                            }
                            i.move{
                                display: none;
                                margin-left: 8px;
                                font-size: 14px;
                            }
                        }
                        .idea:hover{
                            i{
                                display: inline-block;
                            }
                        }
                    }
                    .gutter-box2{
                        .add-point{
                            margin-bottom: 8px;
                            i{
                                display: none;
                                float: right;
                                margin-top: 10px;
                            }
                        }
                        .list-point{
                            margin-bottom: 2px;
                            div{
                                width: 80%;
                                display: inline-block;
                            }
                            i{
                                display: none;
                                margin-left: 8px;
                            }
                        }
                        .list-point:hover{
                            i{
                                display: inline-block;
                            }
                        }
                    }
                    .gutter-box2:hover{
                        .add-point{
                            i{
                                display: inline-block;
                            }
                        }
                    }
                }
            }
            .area{
                div.active{
                    .add{
                        display: inline-block !important;
                    }
                    .remove-line{
                        display: inline-block !important;
                    }
                }
            }
        }
        .content.active{
            padding: 0 340px 60px 240px;
        }
        .detail{
            width: 320px;
            margin-top: 24px;
            height: 100%;
            position: fixed;
            right: 0px;
            top: 47px;
            padding: 12px 12px 0 16px;
            background: #fff;
            .title{
                span:nth-child(1){
                    color: rgba(80, 80, 80, 1);
                    font-size: 18px;
                }
                span:nth-child(2){
                    margin-left: 5px;
                }
            }
            .tags{
                margin-top:16px;
                span{
                    padding:2px 5px;
                    font-size: 12px;
                }
            }
            .max-times{
                span{
                    margin-right: 8px;
                }
                margin-top: 16px;
            }
            .moods{
                span{
                    margin-right: 8px;
                }
                margin-top: 16px;
            }
            .interrupt{
                margin-top: 16px;
                span{
                    margin-right: 8px;
                }
                .ant-radio-button-wrapper{
                    color: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                }
                .ant-radio-button-wrapper-checked:first-child{
                    color: #fff;
                    background: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                }
                .ant-radio-button-wrapper-checked{
                    color: #fff;
                    background: rgba(34, 215, 187, 1);
                    border-color: rgba(34, 215, 187, 1);
                    box-shadow: none;
                }
            }
            .number-list{
                li{
                    margin-top: 8px;
                    input{
                        width: 142px;
                        height: 32px;
                        margin-right: 8px;
                    }
                    .minus-icon{
                        font-size: 18px;
                        margin-right: 4px;
                        color: rgba(204, 204, 204, 1);
                    }
                    .plus-icon{
                        font-size: 18px;
                        color: rgba(34, 215, 187, 1);
                    }
                }
            }
            .warning,.warning-danger{
                display: none;
                margin-top: 72px;
                li{
                    margin-top: 8px;
                    i.warn{
                        color:#FF9900;
                        font-size: 14px;
                    }
                    span.warn{
                        display: inline-block;
                        padding: 2px 8px 2px 0;
                        margin-left: 11px;
                        background: rgba(255, 195, 0, 0.45);
                        font-size: 12px;
                    }
                    i.danger{
                        color:#F5574E;
                        font-size: 14px;
                    }
                    span.danger{
                        display: inline-block;
                        padding: 2px 8px 2px 0;
                        margin-left: 11px;
                        background: rgba(255, 87, 51, 0.45);
                        font-size: 12px;
                    }
                }
            }
            .warning-danger{
                margin-top: 0px;
            }
            .voice-tab{
                background-color: rgba(255, 255, 255, 0);
                border-radius: 4px;
                border: rgba(238, 238, 238, 1) solid 1px;
                .select-list{
                    padding: 16px 0;
                    background: rgba(243, 245, 246, 0.5);
                    div{
                        height: 20px;
                        line-height: 20px;
                        cursor: pointer;
                        font-size:14px;
                        text-align: center;
                        color: rgba(80, 80, 80, 1);
                        margin:10px 0 15px 0;
                    }
                    div:nth-last-child(1){
                        margin:10px 0 0 0;
                    }
                    div.active{
                        color: rgba(34, 215, 187, 1);
                        border-right: 2px solid rgba(34, 215, 187, 1);
                    }
                }
                .voice-option{
                    max-height: 202px;
                    overflow-y: auto;
                    div{
                        div{
                            div:hover{
                                background: rgba(249, 250, 250, 1);
                            }
                            div.active{
                                border: 1px solid rgba(34, 215, 187, 1);
                            }
                        }
                    }
                }
            }
            .right-detail::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
            .right-detail{
                height:100%;
                overflow-y:auto;
                padding-bottom:80px;
                scrollbar-width: none; /* firefox */
                -ms-overflow-style: none; /* IE 10+ */
                overflow-x: hidden;
                overflow-y: auto;
                .working-time-box{
                    div.ant-col-6{
                        margin-top: 8px;
                    }
                }
            }
        }
    }
    .new-intention-modal{
        .intention-name{
            display: flex;
            span{
                display: inline-block;
                width: 70px;
                float: left;
                margin-top: 4px;
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
            }
            input{
                width: 350px;
            }
        }
        .btn-group{
            height: 32px;
            margin-top: 24px;
            button{
                float: right;
                margin-left: 16px;
            }
        }
    }
    .answer-way-modal{
        .intention-name{
            display: flex;
            span{
                display: inline-block;
                width: 70px;
                float: left;
                margin-top: 4px;
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
            }
            input{
                width: 350px;
            }
        }
        .btn-group{
            height: 32px;
            margin-top: 24px;
            button{
                float: right;
                margin-left: 16px;
            }
        }
    }
</style>
